module.exports = __webpack_public_path__ + "img/IconSearch.aad4902d.svg";